import {Component, OnInit, OnDestroy} from '@angular/core';
import {Constants} from 'src/app/shared/utils/constants';
import {AffiliateService} from '../affiliate.service';
import {AppService} from './../../../app.service';
import {NumNotRoundPipe} from 'src/app/shared/pipes/common.pipe';

@Component({
  selector: 'rox-trading-list',
  templateUrl: './trading-volume.component.html',
  styleUrls: ['./trading-volume.component.sass']
})

export class TradingVolumeListComponent implements OnInit, OnDestroy {
  subscription: any = {};
  showResetDialog: Boolean = false;
  showEditSymbolDialog: Boolean = false;
  symbolList = []
  symbolSuffixList = [
    "All",
    ...Constants.SYMBOL_SUFFIX
  ];
  filter = {
    search: "",
    symbolSuffix: "All"
  };
  symbolDetail = {
    readonly: true,
    index:0,
    symbol:'',
    volume:"0",
    point: "0"
  }

  files: any[] = [];
  error:any = false;
  errImportText:any = []
  errImportBeforeSendReq:any = false
  showErrorImport = false
  disableSaveBtn = true

  constructor( 
    private service: AffiliateService,
    private appService: AppService,
    private decimal: NumNotRoundPipe) {}

  ngOnInit(): void {
    this.getListSymbols()
  }

  closePointDialog(){
    this.showEditSymbolDialog = false; 
    this.symbolDetail.readonly = true
  }

  editSymbol(symbol, index):void { 
    this.showEditSymbolDialog = true
    this.error = false
    this.symbolDetail = {
      index:index,
      readonly: true,
      symbol: symbol.symbol,
      volume: symbol.volume,
      point: symbol.point
    }
  }

  getListSymbols(): void{
    const params = {
      q: this.filter.search?this.filter.search.trim():''
    };
    this.subscription.getListSymbols = this.service.getIBListTrading(params).subscribe(
      res=>{
        if(res.status == 1000){
          this.symbolList = res.data
          this.filterBySymbolSuffix(this.filter.symbolSuffix)
          
        }
      }
    )
  }

  filterBySymbolSuffix(symbolSuffix):void{
    if(symbolSuffix != 'All'){
      if(symbolSuffix != 'main'){
        this.symbolList = this.symbolList.filter(s=>s.symbol.toLowerCase().includes(symbolSuffix))
      }else{
        this.symbolList = this.symbolList.filter(s=>s.symbol.split(".").length == 1)
      }
    }
  }

  search():void {
    this.getListSymbols()
  }

  apply():void {
    this.getListSymbols()
  }
 
  editPointDialog():void {
    this.disableSaveBtn = true
    this.symbolDetail.readonly = false
  }

  chooseFileImportCSV():void {
    document.getElementById("symbol-list-trading-import-btn").click()
  }
  handleImportCSV(files): void {
    this.showErrorImport = false
    this.errImportText = []
    this.errImportBeforeSendReq = {}
    if (files && files.length) {
      // read File
      var reader = new FileReader();
      reader.readAsText(files[0]);
      reader.onload = (e: any) => {
        let csv = reader.result as string;
        let listSymbol = csv.split('\r\n');
        for (let idx = 0; idx < listSymbol.length; idx++) {
          let symbol = listSymbol[idx];
          if(idx>0){
            let line = +(idx + 1)
            this.errImportBeforeSendReq['in line '+ line] = []
            if(symbol){
              if(symbol.split(',').length!=3) {
                if(symbol.split(',').length!=1){
                  this.errImportBeforeSendReq['in line '+ line].push('Not correct format')
                }
                continue
              }
            }else{
              continue
            }
            let [name, volume, point] = symbol.split(',')
            if(!name) {
              this.errImportBeforeSendReq['in line '+ line].push('Required name symbol')
            }else{
              if(this.errImportBeforeSendReq[name]){
                this.errImportBeforeSendReq[name].push('Duplicate symbol')
                continue
              }
            }
            this.errImportBeforeSendReq[name] = []
            if(!volume){
              this.errImportBeforeSendReq[name].push('Required volume')
            }
            if(volume.length>12){
              this.errImportBeforeSendReq[name].push('Volume limit length to 12 characters')
            }
            if(+volume<0.001){
              this.errImportBeforeSendReq[name].push('Volume must min = 0.001')
            }
            if(volume.split('.').length>1 && volume.split('.')[1].length>3){
              this.errImportBeforeSendReq[name].push('Volume accept decimal number with 3 decimal places')
            }
            if(!point){
              this.errImportBeforeSendReq[name].push('Required point')
            }
            if(point.length>12){
              this.errImportBeforeSendReq[name].push('Point must limit length to 12 characters')
            }
            if(point.split('.').length>1 && point.split('.')[1].length>2){
              this.errImportBeforeSendReq[name].push('Point accept decimal number with 2 decimal places')
            }
            if(+point<0.01){
              this.errImportBeforeSendReq[name].push('Point must min = 0.01')
            }
          }
        }
        let checkValid = true
        Object.keys(this.errImportBeforeSendReq).map(key=>{
          if(this.errImportBeforeSendReq[key].length > 0){
            this.errImportBeforeSendReq[key].map((e, i)=>{
              this.errImportText.push(`<div class="mb-1"> Symbol <span class='text-red'> ${key} </span> import error. ${e} </div>`)
            })
            checkValid = false
          }
        }
        )
        if(checkValid){
          this.importCSV(files[0])
        }else{
          this.files = []
          this.showErrorImport = true
          this.errImportText = this.errImportText.join('\n')
        }
      }
    }
  }

  checkValidPointConversion():Boolean{
    let check = true
    this.error = []
    if(+this.symbolDetail.volume <0.001){
      this.error.push('Volume must min = 0.001')
      check = false
    }
    if(+this.symbolDetail.point <0.01){
      this.error.push('Point must min = 0.01')
      check = false
    }
    this.error = this.error.join(', ')
    return check
  }

  importCSV(files): void {
      const formData = new FormData();
      formData.append('file', files,"[PROXY]");
      this.subscription.importCSV = this.service.importTradingVolumnCSV(formData)
      .subscribe(res=>{
        if(res.status == 1000){
          this.appService.showSuccess('Import file success');
          this.refresh()
        }else{
          this.appService.showError('Import file fail');
          if(Constants.IMPORT_ERROR_MESSAGE[res.result]){
            this.errImportText = `${Constants.IMPORT_ERROR_MESSAGE[res.result]}`
            this.files = []
            return
          }
          this.errImportText = []
          if(Object.keys(res.data).length>0){
            Object.keys(res.data).map(symbol=>{
              res.data[symbol].map(s=>{
                this.errImportText.push(`<div class="mb-1"> Symbol <span class='text-red'> ${symbol} </span> import error. ${s.message}</div>`)
              })
              
            })
          }
          this.errImportText = this.errImportText.join(" ")
          this.showErrorImport = true
        }
        this.files = []
      });
    }

  refresh():void {
    this.filter = {
      search:"",
      symbolSuffix:'All'
    }
    this.getListSymbols()
  }

  onChangePointConversion(val): void {
    this.error = false
    let oldVolume = this.symbolList[this.symbolDetail.index].volume
    let oldPoint = this.symbolList[this.symbolDetail.index].point
    if( +oldVolume == +this.symbolDetail.volume && +this.symbolDetail.point == +oldPoint){
      this.disableSaveBtn = true
      return
    }
    this.disableSaveBtn = false
  }

  savePointDialog():void {
    let checkValid = this.checkValidPointConversion()
    if(!checkValid) {
      return
    }

    this.showEditSymbolDialog = false;
    this.symbolDetail.readonly = true
    this.symbolList[this.symbolDetail.index] = {
      ... this.symbolList[this.symbolDetail.index],
      symbol: this.symbolDetail.symbol,
      point: this.symbolDetail.point,
      volume: this.symbolDetail.volume
    }
   
    let params = 
    {
      point: + this.symbolDetail.point,
      volume: + this.symbolDetail.volume,
      id: this.symbolList[this.symbolDetail.index].id
    }

    this.subscription.updateSymbol = this.service.updatePointTrading(params).subscribe(
      res=>{
        if(res.status == 1000){
          this.appService.showSuccess('Edit success');
          this.getListSymbols();
        }else{
          this.appService.showError('Edit fail');
          this.refresh()
        }
      }
    )
  }

  ngOnDestroy(): void {
    for (const prop in this.subscription) {
      if (this.subscription[prop]) {
        this.subscription[prop].unsubscribe();
      }
    }
  }
}